import * as R from 'ramda';
import { createSelector } from 'reselect';
import { getVisibleSelectedParametersNames } from '../store/dataset/parameters';
import { getNumericalSummary, getCategoricalSummary } from '../store/dataset/summary';

export const getVisibleCategoricalSummary = createSelector(
  getCategoricalSummary,
  getVisibleSelectedParametersNames,

  (categoricalSummary, visibleParameters) => R.pick(visibleParameters, categoricalSummary)
);

export const getParameterNumericalSummary = (state, parameter) => getNumericalSummary(state)[parameter];
